export default "__VITE_ASSET__DUrih5W3__"